import { graphql } from 'gatsby';
import React from 'react';
import TeamGridMember, { TeamGridMemberProps } from './teamGridSimpleMember';
import './teamGridSimple.scss';

interface Props {
  teamCategory: {
    team: {
      nodes: TeamGridMemberProps[];
    };
  };
}

const TeamGrid: React.FC<Props> = (props) => {
  return (
    <div className="team-grid-simple">
      <div className="grid-row">
        {props.teamCategory.team.nodes.map((item, key) => (
          <div className="team-grid-simple__cell grid-cell" key={key}>
            <TeamGridMember {...item} key={key} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamGrid;

export const query = graphql`
  fragment TeamGridSimpleBlock on WpAcfTeamgridsimpleBlock {
    AcfTeamGridSimple {
      teamCategory {
        team {
          nodes {
            slug
            title
            content
            teamMember {
              position
              title
              contactSocial {
                platform
                link
              }
              cv {
                mediaItemUrl
              }
            }
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 800, quality: 90)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
